/* BookShelf — temporarily parked. Shows a "Coming Soon" placeholder only. */
import React from "react";
import { BookOpen } from "lucide-react";

/* Book strip previously shown on dashboards/landing — parked with the feature. */
export function BookShelfStrip() {
  return null;
}

export default function BookShelf() {
  return (
    <div className="flex flex-col items-center justify-center py-28 text-center" data-testid="bookshelf-coming-soon">
      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#7C3AED]/15 to-[#22D3EE]/15 border border-[#22D3EE]/30 flex items-center justify-center mb-5">
        <BookOpen size={26} className="text-[#22D3EE]" />
      </div>
      <h1 className="font-display font-bold text-3xl tracking-tighter">Coming Soon</h1>
      <p className="text-sm text-neutral-500 mt-2 max-w-sm">The Book Shelf is being crafted — check back shortly.</p>
    </div>
  );
}
